import { useContext, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { TIeForm } from '@/components/App/Leasing/types';
import { DatePickerField, Input, Select } from '@/components/Shared/ui';
import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../../IeOrder';

const ClientInfo: React.FC = () => {
  const { dicts } = useAppSelector((state) => state.dict);

  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<TIeForm>();

  const documentTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.DocumentTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const genders = useMemo(
    () =>
      setDictionaryOptions(DictTypes.Genders, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );
  const familyStatuses = useMemo(
    () =>
      setDictionaryOptions(DictTypes.MaritalStatuses, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );

  return (
    <div className="ie-client-info">
      <div className="ie-order-step__main-title">Информация о Клиенте</div>

      <div className="ie-order-step__grid">
        <Controller
          control={control}
          name="birthDate"
          rules={{
            required: 'Пожалуйста, введите данные',
            validate: (value) => {
              if (!value || value.length !== 'YYYY.MM.DD'.length)
                return 'Пожалуйста, введите данные';
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <DatePickerField
              {...field}
              label="Дата рождения"
              value={field.value || ''}
              onChange={(value) => field.onChange(value)}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
              disableFuture
            />
          )}
        />
        <Controller
          control={control}
          name="documentType"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Select
              {...field}
              label="Тип документа"
              selectedValue={documentTypes.find(
                (item) => item.value === field.value
              )}
              onChange={(value) => field.onChange(value.value)}
              options={documentTypes}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
        <Controller
          control={control}
          name="gender"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Select
              {...field}
              label="Пол"
              selectedValue={genders.find((item) => item.value === field.value)}
              onChange={(value) => field.onChange(value.value)}
              options={genders}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />

        {/* ------------------------------------------ */}

        <Controller
          control={control}
          name="marriageStatus"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Select
              {...field}
              label="Семейное положение"
              selectedValue={familyStatuses.find(
                (item) => item.value === field.value
              )}
              onChange={(value) => field.onChange(value.value)}
              options={familyStatuses}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
        <Controller
          control={control}
          name="childrenCount"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              type="tel"
              value={field.value}
              label="Кол-во несоверш. детей"
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, '');
                if (value.match(/\D/) || value.length > 2) return;
                field.onChange(value);
              }}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
      </div>
    </div>
  );
};

export default ClientInfo;
